import classNames from "classnames";
import React, { PropsWithChildren, ReactNode } from "react";

type HeadingColor = "linen" | "black";

type CardHeaderProps = PropsWithChildren<{
  headingRightContent?: ReactNode;
  headingColor?: HeadingColor;
  extraHeaderClasses?: string;
}>;

export const CardHeader: React.FC<CardHeaderProps> = ({
  headingRightContent,
  headingColor,
  extraHeaderClasses,
  children,
}) => {
  const headerClasses = classNames("card__header", {
    [`card__header--${headingColor}`]: headingColor,
    "card__header--with-side-content": headingRightContent,
    [`${extraHeaderClasses}`]: extraHeaderClasses,
  });

  return (
    <header className={`${headerClasses} ${extraHeaderClasses || ""}`}>
      {children}
      {headingRightContent && <>{headingRightContent}</>}
    </header>
  );
};
